import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tokengeoserver } from "./geoserver/tokengeoserver";
import * as L from "leaflet";
import "rxjs/add/operator/map";
import { Observable } from "rxjs";
import { PortService } from "./port/port.service";
import { Port } from "./port/model/port";

@Injectable()
export class GeocodingService {
  public map: L.Map;
  public geoserverUrl: "geserverURL";
  public geoserverToken: string =
    tokengeoserver.GeosrverProtocolHttps +
    tokengeoserver.Geoservertokenclient +
    tokengeoserver.GeoservertokenServer +
    tokengeoserver.GeoserverTokenmethod +
    tokengeoserver.GeoserverExtention;
  public markersLayer: any;
  constructor(private http: HttpClient, private portsService: PortService) {}

  /* Reverse geocoding pour la recherhe  */
  geocodesearchWFS(port: Port) {
    const encodedName = encodeURIComponent(port.nom);
    const encodedCountry = encodeURIComponent(port.pays);
    const encodedSubdiv = encodeURIComponent(port.subdiv);
    this.portsService.getGeoserverUrl().subscribe(data => {
      return this.http.get(
        data.url +
          "format=jsonv2&city=" +
          encodedName +
          "&country=" +
          encodedCountry +
          "&state=" +
          encodedSubdiv
      );
    });
    return this.http.get(
      this.geoserverToken +
        "format=jsonv2&city=" +
        encodedName +
        "&country=" +
        encodedCountry +
        "&state=" +
        encodedSubdiv
    );
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/geocoding.service.ts